import { createClient } from '@supabase/supabase-js';
import { isRenderMode, RENDER_DATA, makeRenderClient } from './renderMode';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

let client;
if (isRenderMode) {
  // Export pipeline: serve every query from the injected dataset — no network, no auth.
  client = makeRenderClient(RENDER_DATA);
} else {
  if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase environment variables. Check your .env file.');
  }
  client = createClient(supabaseUrl, supabaseKey);
}

export const supabase = client;
